import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Select from 'react-select';
import { updateBookletMutation } from '../../queries/queries';
import { GET_BOOKLETS_WITH_SERIES } from '../../queries/bookletSeries';
import Modal from '../../common/Modal';

function MoveToSeriesModal({ booklet, series, zoneId, onClose }) {
  const [selectedSeriesId, setSelectedSeriesId] = useState('');
  const [error, setError] = useState('');

  const [updateBooklet, { loading }] = useMutation(updateBookletMutation, {
    refetchQueries: [{ query: GET_BOOKLETS_WITH_SERIES, variables: { zoneId } }],
    onCompleted: () => onClose(),
    onError: (err) => setError(err.message),
  });

  const buildVariables = (seriesId) => ({
    _id: booklet._id,
    title: booklet.title,
    subtitle: booklet.subtitle,
    adminEmails: booklet.adminEmails || [],
    couponIds: (booklet.couponIds || []).map(id => id.toString()),
    buyableFrom: booklet.buyableFrom,
    buyableTo: booklet.buyableTo,
    validFrom: booklet.validFrom,
    validTo: booklet.validTo,
    price: booklet.price,
    totalCommission: booklet.totalCommission,
    supportCommissionToAssociation: booklet.supportCommissionToAssociation,
    supportCommissionToMainAssociation: booklet.supportCommissionToMainAssociation,
    logoURL: booklet.logoURL,
    colorLeft: booklet.colorLeft,
    colorRight: booklet.colorRight,
    colorFont: booklet.colorFont,
    colorSalesMaterial: booklet.colorSalesMaterial,
    sponsors: booklet.sponsors,
    imageOfBookletInAppURL: booklet.imageOfBookletInAppURL,
    imageOfSingleBookletInAppURL: booklet.imageOfSingleBookletInAppURL,
    purchasableThroughAssociations: booklet.purchasableThroughAssociations || [],
    mainAssociationId: booklet.mainAssociationId,
    categorySettings: booklet.categorySettings.map(({ __typename, ...rest }) => rest) || [],
    textInsidePrintedBooklet: booklet.textInsidePrintedBooklet,
    bookletSeriesId: seriesId,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedSeriesId) {
      setError('Välj en serie');
      return;
    }
    updateBooklet({ variables: buildVariables(selectedSeriesId) });
  };

  const options = series.map((s) => ({
    value: s._id,
    label: `${s.name} (${s.booklets.length} ${s.booklets.length === 1 ? 'häfte' : 'häften'})`,
  }));

  const selectedOption = options.find((o) => o.value === selectedSeriesId) || null;

  return (
    <Modal isOpen closeModal={onClose} className="modal-clone-booklet">
      <h3>Byt serie för häfte</h3>

      <div style={{ textAlign: 'left', margin: '1.5rem 0' }}>
        <p><strong>{booklet.title}</strong></p>
        {booklet.subtitle && <p style={{ fontSize: '0.85rem', color: 'rgba(0,0,0,0.6)' }}>{booklet.subtitle}</p>}
      </div>


      <form onSubmit={handleSubmit}>
        <div style={{ textAlign: 'left', margin: '1.5rem 0' }}>
          <Select
            value={selectedOption}
            onChange={(option) => setSelectedSeriesId(option ? option.value : '')}
            options={options}
            placeholder="Välj en serie..."
            isClearable
            isDisabled={loading}
          />
        </div>

        {error && <p style={{ color: 'red', margin: '0.5rem 0' }}>{error}</p>}

        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginTop: '2rem' }}>
          <button type="button" className="secondary" onClick={onClose} disabled={loading}>
            Avbryt
          </button>
          <button type="submit" className="primary" disabled={loading}>
            {loading ? 'Sparar...' : 'Byt serie'}
          </button>
        </div>
      </form>
    </Modal>
  );
}

MoveToSeriesModal.propTypes = {
  booklet: PropTypes.object.isRequired,
  series: PropTypes.array.isRequired,
  zoneId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default MoveToSeriesModal;
